// MONCHO — scripts propios de las secciones mt-*

function mtInitReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  els.forEach(function (el) { observer.observe(el); });
}

function mtInitFaq() {
  var items = document.querySelectorAll('.mt-faq__item');
  if (!items.length) return;

  items.forEach(function (item) {
    var boton = item.querySelector('.mt-faq__pregunta');
    var respuesta = item.querySelector('.mt-faq__respuesta');
    if (!boton || !respuesta) return;

    boton.addEventListener('click', function () {
      var abierto = item.getAttribute('data-abierto') === 'true';

      items.forEach(function (otro) {
        if (otro !== item) {
          otro.setAttribute('data-abierto', 'false');
          var r = otro.querySelector('.mt-faq__respuesta');
          if (r) r.style.maxHeight = null;
        }
      });

      if (abierto) {
        item.setAttribute('data-abierto', 'false');
        respuesta.style.maxHeight = null;
      } else {
        item.setAttribute('data-abierto', 'true');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

function mtInitContador() {
  var els = document.querySelectorAll('.mt-contador');
  if (!els.length) return;

  var animar = function (el) {
    var fin = parseInt(el.dataset.hasta, 10) || 0;
    var duracion = 1400;
    var inicio = null;

    var paso = function (ts) {
      if (!inicio) inicio = ts;
      var progreso = Math.min((ts - inicio) / duracion, 1);
      var valor = Math.floor(progreso * fin);
      el.textContent = valor.toLocaleString('es-CO');
      if (progreso < 1) requestAnimationFrame(paso);
      else el.textContent = fin.toLocaleString('es-CO');
    };

    requestAnimationFrame(paso);
  };

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animar(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );

  els.forEach(function (el) { observer.observe(el); });
}

function mtInitGaleriaProducto() {
  var galerias = document.querySelectorAll('.mt-producto__galeria');
  if (!galerias.length) return;

  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('.mt-producto__img-principal');
    var minis = galeria.querySelectorAll('.mt-producto__mini');
    if (!principal || !minis.length) return;

    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var full = mini.dataset.full;
        if (!full) return;
        principal.src = full;
        minis.forEach(function (m) { m.classList.remove('mt-producto__mini--activa'); });
        mini.classList.add('mt-producto__mini--activa');
      });
    });
  });
}

function mtInitVariantes() {
  var formularios = document.querySelectorAll('.mt-producto__form');
  if (!formularios.length) return;

  formularios.forEach(function (form) {
    var dataEl = form.querySelector('.mt-producto__variantes-json');
    var selects = form.querySelectorAll('.mt-producto__select-opcion');
    var inputId = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('.mt-producto__precio-actual');
    var precioAntesEl = form.querySelector('.mt-producto__precio-antes');
    var botonComprar = form.querySelector('.mt-producto__btn-comprar');

    if (!dataEl || !selects.length) return;

    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var formatearMoneda = function (centavos) {
      if (window.Shopify && Shopify.formatMoney && window.mtMoneyFormat) {
        return Shopify.formatMoney(centavos, window.mtMoneyFormat);
      }
      return (centavos / 100).toFixed(2);
    };

    var actualizar = function () {
      var seleccion = Array.from(selects).map(function (s) { return s.value; });

      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });

      if (!variante) return;

      if (inputId) inputId.value = variante.id;
      if (precioEl) precioEl.textContent = formatearMoneda(variante.price);

      if (precioAntesEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAntesEl.textContent = formatearMoneda(variante.compare_at_price);
          precioAntesEl.style.display = '';
        } else {
          precioAntesEl.style.display = 'none';
        }
      }

      if (botonComprar) {
        if (variante.available) {
          botonComprar.disabled = false;
          botonComprar.textContent = botonComprar.dataset.textoDisponible || botonComprar.textContent;
        } else {
          botonComprar.disabled = true;
          botonComprar.textContent = botonComprar.dataset.textoAgotado || 'Agotado';
        }
      }
    };

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  mtInitReveal();
  mtInitFaq();
  mtInitContador();
  mtInitGaleriaProducto();
  mtInitVariantes();
});
